import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPurchasePayment } from "api/purchasePayment.api";
import {
  invalidatePurchasePaymentSide,
  invalidateExpenseSide,
} from "lib/cacheInvalidation";

export const useCreatePurchasePayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPurchasePayment,
    onSuccess: () => {
      invalidatePurchasePaymentSide(queryClient);
      invalidateExpenseSide(queryClient); // settling bills changes their status
    },
  });
};
